import { summaryTransitYBIValidate } from "../../application/dtos/summary_transit_ybi_validate";

export class summaryTransitYBIEntity {
    constructor( data ){ // cuando se recive un objeto con propiedades indefinidas en vez de las propiedades definidad de un objeto
        this.data = data
    }

    isValid() {
        return summaryTransitYBIValidate(this);
    }
}